import { Route, Routes } from 'react-router-dom';
import ConfigManagementPage from './config-management';
const ConfigManagementRouter: React.FC = () => {
  return(
  <Routes>
    <Route path="/" element={<ConfigManagementPage />} />
  </Routes>
  )
}

export default ConfigManagementRouter
